
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bike-adventures",
      function () {
        return require("private-next-pages/bike-adventures.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bike-adventures"])
      });
    }
  